import React from "react";
import { BiMoveVertical } from "react-icons/bi";

export default function StaticItem({ field }) {
  const ui = field["x-ui"];
  const title = field.title || "(Sans titre)";

  return (
    <div className="bg-body border rounded p-2 mb-2 d-flex gap-2 align-items-start">

      {/* === DRAG HANDLE (visuel, réel drag géré par Pangea) === */}
      <span className="text-muted" style={{ cursor: "grab" }}>
        <BiMoveVertical size={18} />
      </span>

      {/* === CONTENU PRINCIPAL === */}
      <div className="flex-grow-1">

        {/* Titre + type */}
        <div className="d-flex align-items-center justify-content-between">
          <span className="fw-semibold">• {title}</span>
          <code className="small text-muted ms-3">{ui}</code>
        </div>

        {/* Contenu selon le type */}
        <div className="mt-2 small">
          {ui === "staticText" &&
            <div
              className="text-muted"
              dangerouslySetInnerHTML={{
                __html: field.content || "Texte statique vide…",
              }}
            />
          }
          {ui === "staticTitle" && (
            <div className="fw-bold">
              {field.content || "Titre statique"}
            </div>
          )}

          {ui === "separator" && (
            <hr className="my-2" />
          )}
        </div>

      </div>
    </div>
  );
}
